;(function () {
  'use strict'

  angular.module('deskfy.arts').controller('businessDataItemController', businessDataItemController)

  /* @ngInject */
  function businessDataItemController ($scope, $rootScope, $q, ModalService, AssetService) {
    const getBusinessDataCreateEditDialogController = () =>
      $q.when(import('../../dialogs/business-data/create-edit/business-data-create-edit-dialog.controller'))
    const getDeleteContextDialogController = () =>
      $q.when(import('../../dialogs/delete-context/delete-context-dialog.controller'))

    $scope.businessData = []
    $scope.maxItems = []
    $scope.limit = 4
    $rootScope.selectedContext = $rootScope.oUser.contextId

    const api = {
      getBusinessDataCreateEditDialogController,
      getDeleteContextDialogController
    }

    this.getApi = () => api

    activate()

    function activate () {
      $scope.data.placeholders.forEach(placeholder => {
        if (placeholder.type === 'IMAGE') {
          const info = placeholder.contexts.find(
            item => item.userId === $rootScope.oUser.id && item.id === $scope.data.id
          )
          if (info && info.contextValue.assetId) {
            placeholder.file = info.contextValue
            AssetService.getAssetDetailsById(placeholder.file.assetId).then(res => {
              placeholder.file.name = res.name
              placeholder.file.size = res.size
            })
          }
        }
      })
    }

    $scope.getFileUrl = function (fileId) {
      return AssetService.getAssetUrlThumbnail(fileId)
    }

    $scope.viewMore = key => {
      if ($scope.maxItems[key] === 4 || $scope.maxItems[key] === undefined) {
        $scope.maxItems[key] = $scope.data.placeholders.length
      } else {
        $scope.maxItems[key] = 4
      }
    }

    $scope.changeLocation = contextId => {
      if ($scope.page !== 'profile') {
        $rootScope.selectedContext = contextId
      }
    }

    $scope.deleteContext = (contextId, contextName) => {
      api.getDeleteContextDialogController().then(({ DeleteContextDialogController }) => {
        if ($rootScope.oUser.contextId === contextId) {
          ModalService.close()
          ModalService.showModal({
            templateId: 'deleteContextDialog.html',
            templateUrl: '/arts/dialogs/delete-context/delete-context-dialog.html?$$REVISION$$',
            destroyable: true,
            observeChanges: true,
            allowMultiple: true,
            controller: DeleteContextDialogController
          })
        } else {
          ModalService.close()
          ModalService.showModal({
            templateId: 'deleteContextDialog.html',
            templateUrl: '/arts/dialogs/delete-context/delete-context-dialog.html?$$REVISION$$',
            destroyable: true,
            observeChanges: true,
            allowMultiple: true,
            controller: DeleteContextDialogController,
            data: {
              contextId,
              contextName
            }
          })
        }
      })
    }

    $scope.editContext = (contextId, page) => {
      ModalService.close()
      api.getBusinessDataCreateEditDialogController().then(({ BusinessDataCreateEditDialogController }) => {
        ModalService.showModal({
          templateId: 'businessDataCreateEditDialog.html',
          templateUrl: '/arts/dialogs/business-data/create-edit/business-data-create-edit-dialog.html?$$REVISION$$',
          destroyable: true,
          observeChanges: true,
          allowMultiple: true,
          controller: BusinessDataCreateEditDialogController,
          data: {
            contextId,
            page,
            downloadCallback: $scope.downloadCallback,
            linkedTemplate: $scope.linkedTemplate,
            originModalReference: $scope.originModalReference
          }
        })
      })
    }
  }
})()
